<template>
  <section>      
    <v-list
      subheader
      two-line
    >
      <v-list-item-group>
        <v-list-item 
          v-for="(document, index) in documents" 
          :key="index" 
          :dense="true" 
          :selectable="false"
        >
          <v-list-item-avatar>
            <v-icon>{{ document.imageable ? 'image' : 'description' }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>              
              {{ document.document_type.name }}
            </v-list-item-title>

            <v-list-item-subtitle v-if="document.content.filename">
              <span>Arquivo: {{ document.content.filename }}</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle>              
              <v-chip
                small
                class="mt-1 mb-1"
                :color="fetchStatusColor(document.status.raw)"
              >
                {{ document.status.label }}
              </v-chip>              
            </v-list-item-subtitle>

            <v-list-item-subtitle>
              <p
                v-if="document.reason"
                class="mb-0"
              >
                <strong class="mr-1">
                  Motivo Rejeição: {{ document.reason }}
                </strong>                
              </p>                                   
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action style="flex-direction: row; align-items: center;">
            <OrderDocumentUploadModal
              :order="order"
              :document="document" 
              @close="closeUploadModal()"                 
            />  

            <OrderDocumentDownloadButton   
              :order="order"
              :document="document"
            />

            <OrderDocumentInfoButton
              v-if="document.content.url"
              :order="order"
              :documentId="document.id"
              @close="fetchDocuments()"
            />
          </v-list-item-action>
        </v-list-item>        
      </v-list-item-group>
    </v-list> 
  </section>
</template>

<script>
  import OrderService from '@/services/pedidos.service';
  import OrderDocumentUploadModal from './OrderDocumentUploadModal.vue';
  import OrderDocumentDownloadButton from './OrderDocumentDownloadButton.vue';
  import OrderDocumentInfoButton from './OrderDocumentInfoButton.vue';
  import { documentStatusColor } from '@/util/document-status-color';
import { mapActions } from 'vuex';

  export default {
    name: 'OrderDocumentList',

    components: {
      OrderDocumentUploadModal,
      OrderDocumentDownloadButton,
      OrderDocumentInfoButton
    },

    props: {
      order: {
        type: Object,
        required: true
      },
    },

    data: () => ({
      documents: [],
    }), 

    watch: {
      order: {
        immediate: true,
        handler() {
          this.fetchDocuments();
        }
      }
    },

    methods: {
      fetchDocuments() {
        OrderService.listDocuments(this.order.id).subscribe(response => {
          this.documents = response;
        });
      },

      closeUploadModal() {    
        this.fetchOrder(this.order.id);  
        this.fetchDocuments();
      },

      fetchStatusColor(statusCode) {
        return documentStatusColor(statusCode);
      },

      ...mapActions('order', { 
        fetchOrder: 'SHOW',        
      }),
    },
  };
</script>
